import Vue from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';
import zh_CN from './zh_CN';
import en from './en';
import storage from '@/utils/storage';

Vue.use(VueI18n);

const messages: LocaleMessages = {
  en: {
    ...en,
  },
  zh: {
    ...zh_CN,
  },
};

export const getLocale = () => {
  const localLanguage = storage.localGet('language');
  if (localLanguage) {
    document.documentElement.lang = localLanguage;
    return localLanguage;
  }
  const language = navigator.language.toLocaleLowerCase();
  const locales = Object.keys(messages);
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      document.documentElement.lang = locale;
      return locale;
    }
  }
  return 'en';
};

export default new VueI18n({
  locale: getLocale(),
  messages,
});
